import React, { useState } from "react";
import axios from "axios";
import { useFormik } from "formik";
import bootstrap from "bootstrap/dist/css/bootstrap.min.css";
import { Modal, Button } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import "./styles/form.css";
import * as Yup from "yup";
import { loadProgressBar } from "x-axios-progress-bar";
import "x-axios-progress-bar/dist/nprogress.css";
import { subDays, format } from "date-fns";
import { APICall, formatLocaleDate, onClickObserved } from "./utilities";
import SelectResponses from "./form_components/SelectResponses";
import ModalGetTrees from "./form_components/ModalGetTrees";

require("dotenv").config();
console.log(process.env);

//const port = process.env.REACT_APP_PORT2;
const baseUrl = process.env.REACT_APP_HOST;
let notPastWeekObs;
let pastWeekDate;

const DataForm = () => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showModalGetTrees, setShowModalGetTrees] = useState(false);
  const handleClose = () => {
    setShowConfirmationModal(false);
  };
  const handleOpen = () => setShowConfirmationModal(true);

  loadProgressBar();
  const formik = useFormik({
    initialValues: {
      plantId: "",
      lastName: "",
      genus: "",
      species: "",
      dateEntered: formatLocaleDate(
        new Date()
          .toLocaleString("en-US", { timeZone: "America/Chicago" })
          .substring(0, 10)),
      dateObserved: formatLocaleDate(
        new Date()
          .toLocaleString("en-US", { timeZone: "America/Chicago" })
          .substring(0, 10)
      ), // Should timezone be hardcoded?
      breakingLeafBuds: "",
      leafObserved: "",
      leafIncreasingSize: "",
      leafColorObserved: "",
      leafFallingObserved: "",
      flowerBudsObserved: "",
      flowerOpenObserved: "",
      flowerPollenObserved: "",
      fruitObserved: "",
      fruitRipeObserved: "",
      fruitDropObserved: "",
      leafIntensity: "",
      breakingLeafBudsIntensity: "",
      leafIncreasingInSizeIntensity: "",
      leafColorIntensity: "",
      leafFallingObservedIntensity: "",
      flowerBudsIntensity: "",
      flowerOpenIntensity: "",
      flowerPollenReleaseIntensity: "",
      fruitIntensity: "",
      fruitRipeIntensity: "",
      fruitDropIntensity: "",
      comments: "",
    },
    validationSchema: Yup.object({
      plantId: Yup.string()
        .max(30, "Please enter a Plant ID.")
        .required("Tree ID is Required"),
      lastName: Yup.string()
        .max(30, "Please enter a last name.")
        .required("Last Name of Observer is Required"),
      genus: Yup.string()
        .max(30, "Please enter the genus.")
        .required("Genus is Required"),
      species: Yup.string()
        .max(30, "Please enter the species.")
        .required("Species is Required"),
      dateEntered: Yup.date().required("Please select a data entry date."),
      dateObserved: Yup.date().required("Please select a date observed."),
      breakingLeafBuds: Yup.string()
        .min(1)
        .max(1, "Please select a value for Breaking Leaf Buds Observed.")
        .required("Breaking Leaf Buds is Required"),
      leafObserved: Yup.string()
        .min(1)
        .max(1, "Please select a value for Leaf Observed.")
        .required("Leaf Observation is Required"),
      leafColorObserved: Yup.string()
        .min(1)
        .max(1, "Please select a value for Leaf Color Observed.")
        .required("Leaf Color Observation is Required"),
      leafIncreasingSize: Yup.string()
        .min(1)
        .max(1, "Please select a value for Leaf Increasing in Size.")
        .required("Leaf Increasing in Size Observation is Required"),
      leafFallingObserved: Yup.string()
        .min(1)
        .max(1, "Please select a value for Leaf Falling Observed.")
        .required("Leaf Falling Observation is Required"),
      flowerBudsObserved: Yup.string()
        .min(1)
        .max(1, "Please select a value for Flower/Flower Buds Observed.")
        .required("Flower/Flower Buds Observation is Required"),
      flowerOpenObserved: Yup.string()
        .min(1)
        .max(1, "Please select a value for Flower Open Observed.")
        .required("Flower Open Observation is Required"),
      flowerPollenObserved: Yup.string()
        .min(1)
        .max(1, "Please select a value for Flower Pollen Release Observed.")
        .required("Flower Pollen Release Observation is Required"),
      fruitObserved: Yup.string()
        .min(1)
        .max(1, "Please select a value for Fruit Observed.")
        .required("Fruit Observation is Required"),
      fruitDropObserved: Yup.string()
        .min(1)
        .max(1, "Please select a value for Fruit Drop Observed.")
        .required("Fruit Drop Observation is Required"),
      fruitRipeObserved: Yup.string()
        .min(1)
        .max(1, "Please select a value for Fruit Ripe Observed.")
        .required("Fruit Ripe Observation is Required"),
    }),
    onSubmit: (values) => {
      console.log(values);
      APICall(formik, baseUrl, handleOpen);
    },
  });

  const expand = (event) => {
    console.log("Expanding "+event.target.getAttribute("data-target"))
    var elem = event.target.getAttribute("data-target");
    const elems = elem.split(",");
    elems.forEach((element) => {
      document.querySelector(element).style.display = "block";
    });
    formik.handleChange(event);
  };

  const collapse = (event) => {
    console.log("Collapsing "+event.target.getAttribute("data-target"))
    var elem = event.target.getAttribute("data-target");
    var elems = elem.split(",");
    elems.forEach((element) => {
      document.querySelector(element).style.display = "none";
    });
    var i = event.target.getAttribute("data-collapse");
    var iStr = i.slice(1);
    console.log(i, iStr);
    document.querySelector(i).selectedIndex = 0;
    formik.values[iStr] = "";
    formik.handleChange(event);
  };

  return (
    <div class="App">
      <div class="TreeObservationsForm">
        <img class="logo" src="Logo_square.jpeg" alt="" ></img>
        <div align="center">
          <form
            onSubmit={(event) => {
              event.preventDefault();
            }}
            id="DataEntryForm"
          >
            {" "}
            {/*comment changed attribute  onSubmit={formik.handleSubmit}*/}
            <legend>Data Entry Form</legend>
            <div class="UploadDiv">
              <label class="UploadLabel">Upload Image(optional) </label>
              <br />
              <input
                class="mb-2"
                id="file"
                name="file"
                type="file"
                label=""
                accept=".jpg"
                onChange={() => {
                  alert("Translating text. Please wait.");
                  const data = new FormData();
                  data.append("file", document.getElementById("file").files[0]);

                  axios.post(baseUrl + "callAPITranslate", data).then((res) => {
                    var id = res.data.match(/[0-9|a-z]+-[0-9]{2,4}\*[0-9]+/);
                    formik.values.plantId = id[0];
                    document.getElementById("plantId").value = id[0];
                    alert("Result: \n" + res.data);
                    axios
                      .get(baseUrl + "getTreeData", {
                        params: { plantid: formik.values.plantId },
                      })
                      .then((result) => {
                        if (result.data[0] !== undefined) {
                          console.log(res.data);
                          formik.values.genus = result.data[0].Genus;
                          formik.values.species = result.data[0].Species;
                          document.getElementById("genus").value =
                            result.data[0].Genus;
                          document.getElementById("species").value =
                            result.data[0].Species;
                          axios
                            .get(baseUrl + "getName", {
                              params: {
                                plantid: formik.values.plantId,
                                genus: formik.values.genus,
                              },
                            })
                            .then((resName) => {
                              var nameslist =
                                document.getElementById("observerNamesList");
                              while (nameslist.hasChildNodes()) {
                                nameslist.removeChild(nameslist.firstChild);
                              }
                              document.getElementById("lastName").value = "";
                              formik.values.lastName = "";
                              var name;
                              var option;
                              for (name in resName.data) {
                                option = document.createElement("option");
                                option.value = resName.data[name].ObserverID;
                                option.label = resName.data[name].ObserverID;
                                document
                                  .getElementById("observerNamesList")
                                  .appendChild(option);
                              }
                              document.getElementById("lastName").value =
                                resName.data[0].ObserverID;
                              formik.values.lastName =
                                resName.data[0].ObserverID;
                            });
                        } else {
                        }
                      });
                  });
                }}
              />
            </div>
            <div class="BasicInfo">
              <table align="center" class="BasicInfoTable">
                <tr>
                  <td class="BasicInfoLabel">
                    <label
                      class="entry-component FormLabel" //added commented out class FormLabel to this class
                      className="font-weight-bold"
                      // class="FormLabel"
                    >
                      Tree ID{" "}
                    </label>
                  </td>
                  <td class="BasicInput">
                    <input
                      id="plantId"
                      name="plantId"
                      type="string"
                      onChange={formik.handleChange}
                      value={formik.values.plantId}
                      list="treeIDList"
                      onFocus={() => {
                        axios
                          .get(baseUrl + "findTree", {
                            params: {
                              PlantID: formik.values.plantId,
                            },
                          })
                          .then((result) => {
                            console.log("TREE ENTERED",
                              "findTree",
                              result.data,
                              result.data === "Tree ID not in database"
                            );
                            if (result.data === "Tree ID not in database") {
                              axios.get(baseUrl + "getAllTrees").then((res) => {
                                console.log(res);
                                var treeslist =
                                  document.getElementById("treeIDList");
                                while (treeslist.hasChildNodes()) {
                                  treeslist.removeChild(treeslist.firstChild);
                                }
                                var tree;
                                var option;
                                for (tree in res.data) {
                                  option = document.createElement("option");
                                  option.value = res.data[tree].PlantID;
                                  option.label = res.data[tree].PlantID;
                                  document
                                    .getElementById("treeIDList")
                                    .appendChild(option);
                                }
                              });
                            }
                          });
                      }}
                      onBlur={() => {
                        console.log("Tree ID lost focus"+formik.values.plantId);
                        axios
                          .get(baseUrl + "findTree", {
                            params: {
                              PlantID: formik.values.plantId,
                            },
                          })
                          .then((result) => {
                            if (result.data === "Tree ID not in database") {
                              axios.get(baseUrl + "getAllTrees").then((res) => {
                                var treeslist =
                                  document.getElementById("treeIDList");
                                while (treeslist.hasChildNodes()) {
                                  treeslist.removeChild(treeslist.firstChild);
                                }
                                var tree;
                                var option;
                                for (tree in res.data) {
                                  option = document.createElement("option");
                                  option.value = res.data[tree].PlantID;
                                  option.label = res.data[tree].PlantID;
                                  document
                                    .getElementById("treeIDList")
                                    .appendChild(option);
                                }
                              });
                            }
                          });
                      }}
                    />
                    {formik.touched.plantId && formik.errors.plantId ? (
                      <div class="Error">{formik.errors.plantId}</div>
                    ) : null}
                    <button
                      class="search btn btn-success"
                      type="button"
                      onClick={() => {
                        console.log("Plant ID provided:",formik.values.plantId, formik.values.plantId !== "");
                        if (formik.values.plantId !== "") {
                          axios
                            .get(baseUrl + "getTreeInfo", {
                              params: { plantid: formik.values.plantId },
                            })
                            .then((res) => {
                              var fullName = res.data[0].Taxon
                              var nameFields = fullName.split(" ");
                              var collection = nameFields[0];
                              console.log("Collection:",collection, typeof(nameFields));
                              if (res.data[0] !== undefined) {
                              console.log(res.data);
                              formik.values.genus = collection;
                              formik.values.species = nameFields.slice(1).join(" ");
                              document.getElementById("genus").value = formik.values.genus;
                              document.getElementById("species").value = 
                                                                  formik.values.species
                              axios
                                .get(baseUrl + "getName", {
                                  params: {
                                    plantid: formik.values.plantId,
                                    genus: formik.values.genus,
                                  },
                                })
                                .then((resName) => {
                                  var nameslist =
                                    document.getElementById(
                                      "observerNamesList"
                                    );
                                  while (nameslist.hasChildNodes()) {
                                    nameslist.removeChild(
                                      nameslist.firstChild
                                    );
                                  }
                                  document.getElementById(
                                    "lastName"
                                  ).value = "";
                                  formik.values.lastName = "";
                                  var name;
                                  var option;
                                  for (name in resName.data) {
                                    option =
                                      document.createElement("option");
                                    option.value =
                                      resName.data[name].ObserverID;
                                    option.label =
                                      resName.data[name].ObserverID;
                                    document
                                      .getElementById(
                                        "observerNamesList"
                                      )
                                      .appendChild(option);
                                  }
                                  document.getElementById(
                                    "lastName"
                                  ).value = resName.data[0].ObserverID;
                                  formik.values.lastName =
                                    resName.data[0].ObserverID;
                                });
                              } 
                            })
                            .catch((error) => {
                              console.log("ERROR: Check Collection:" + error);
                              alert("Tree not in collection");
                            });
                        } else {
                          console.log("No PlantID supplied");
                        }
                      }}
                    >
                      Check
                    </button>
                  </td>
                </tr>
                <tr>
                  <td class="BasicInfoLabel">
                    <label
                      class="entry-component FormLabel" //added commented out class FormLabel to this class
                      className="font-weight-bold"
                      //class="FormLabel"
                    >
                      Name{" "}
                    </label>
                  </td>
                  <td class="BasicInput" id="namesEntry">
                    <input
                      id="lastName"
                      name="lastName"
                      type="string"
                      onChange={formik.handleChange}
                      value={formik.values.lastName}
                      list="observerNamesList"
                      onFocus={() => {
                        if (
                          document
                            .getElementById("observerNamesList")
                            .hasChildNodes() === false
                        ) {
                          axios.get(baseUrl + "getAllNames").then((res) => {
                            console.log(res.data);
                            console.log(res.data[0].ObserverID);
                            var name;
                            var option;
                            for (name in res.data) {
                              option = document.createElement("option");
                              option.value = res.data[name].ObserverID;
                              option.label = res.data[name].ObserverID;
                              document
                                .getElementById("observerNamesList")
                                .appendChild(option);
                            }
                          });
                        }
                      }}
                      onBlur={() => {
                        axios
                          .get(baseUrl + "findName", {
                            params: {
                              ObserverID: formik.values.lastName,
                            },
                          })
                          .then((result) => {
                            if (result.data === "Name not in database") {
                              axios.get(baseUrl + "getAllNames").then((res) => {
                                console.log(res.data);
                                console.log(res.data[0].ObserverID);
                                var nameslist =
                                  document.getElementById("observerNamesList");
                                while (nameslist.hasChildNodes()) {
                                  nameslist.removeChild(nameslist.firstChild);
                                }
                                var name;
                                var option;
                                for (name in res.data) {
                                  option = document.createElement("option");
                                  option.value = res.data[name].ObserverID;
                                  option.label = res.data[name].ObserverID;
                                  document
                                    .getElementById("observerNamesList")
                                    .appendChild(option);
                                }
                              });
                            } else {
                              axios
                                .get(baseUrl + "getTrees", {
                                  params: { observer: formik.values.lastName },
                                })
                                .then((res) => {
                                  var treeslist =
                                    document.getElementById("treeIDList");
                                  while (treeslist.hasChildNodes()) {
                                    treeslist.removeChild(treeslist.firstChild);
                                  }
                                  var tree;
                                  var option;
                                  for (tree in res.data) {
                                    option = document.createElement("option");
                                    console.log(
                                      "TREELIST:" + res.data[tree].PlantID
                                    );
                                    option.value = res.data[tree].PlantID;
                                    option.label = res.data[tree].PlantID;
                                    document
                                      .getElementById("treeIDList")
                                      .appendChild(option);
                                  }
                                });
                            }
                          });
                      }}
                    />
                    <datalist id="treeIDList"></datalist>
                    <datalist id="observerNamesList"></datalist>
                    {formik.touched.lastName && formik.errors.lastName ? (
                      <div class="Error">{formik.errors.lastName}</div>
                    ) : null}

                    <button
                      type="button"
                      class="search btn btn-success"
                      onClick={() => {
                        console.log("LOG:Get Trees Button Entered\n");

                        if (formik.values.lastName !== "") {
                          console.log(
                            "LOG:Get Trees: formik.values.lastName: " +
                              formik.values.lastName
                          );
                          pastWeekDate = format(
                            subDays(new Date(formik.values.dateEntered), 2), 
                            "yyyy-MM-dd"
                          );
                          axios
                            .get(baseUrl + "getNotObserved", {
                              params: { date: pastWeekDate, lastName: formik.values.lastName },
                            })
                            .then((res) => {
                              console.log(
                                "LOG:Get Trees:getNotObserved:",
                                res.data
                              );
                              axios
                                .get(baseUrl + "getObsListTrees", {
                                  params: {
                                    observer: formik.values.lastName,
                                    genus: formik.values.genus,
                                  },
                                })
                                .then((result) => {
                                  console.log(
                                    "LOG:Get Trees:getObsListTrees: PlantID: ",
                                    result.data[0].PlantID,
                                    "LOG:Get Trees:getObsListTrees:genus: ",
                                    formik.values.genus
                                  );
                                  notPastWeekObs = [];
                                  var notInList = true;
                                  for (var i = 0; i < result.data.length; i++) {
                                    notInList = true;
                                    for (var j = 0; j < res.data.length; j++) {
                                      if (
                                        result.data[i].PlantID ===
                                        res.data[j].PlantID
                                      ) {
                                        notInList = false;
                                      }
                                    }
                                    if (notInList === true) {
                                      notPastWeekObs.push({
                                        plantId: result.data[i].PlantID,
                                        genus:
                                          result.data[i].Taxon.split(" ")[0],
                                        list: result.data[i].List,
                                      });
                                      console.log(
                                        "Get Trees Button: result.data[i] ",
                                        result.data[i]
                                      );
                                    }
                                  }
                                  setShowModalGetTrees(true);
                                });
                            });
                        }
                      }}
                    >
                      Get Trees
                    </button>
                    <ModalGetTrees
                      baseUrl={baseUrl}
                      formik={formik}
                      handleClose={handleClose}
                      notPastWeekObs={notPastWeekObs}
                      pastWeekDate={pastWeekDate}
                      show={showModalGetTrees}
                      setShowModalGetTrees={setShowModalGetTrees}
                    />
                  </td>
                </tr>

                <tr>
                  <td class="BasicInfoLabel">
                    <label
                      class="entry-component FormLabel" //added commented out class FormLabel to this class
                      className="font-weight-bold"
                      //class="FormLabel"
                    >
                      Genus{" "}
                    </label>
                  </td>
                  <td class="BasicInput">
                    <input
                      id="genus"
                      name="genus"
                      type="string"
                      onChange={formik.handleChange}
                      value={formik.values.genus}
                      list="genusList"
                      onFocus={() => {
                        axios.get(baseUrl + "getCollectionsList").then((res) => {
                          let collectionslist =
                            document.getElementById("genusList");
                          while (collectionslist.hasChildNodes()) {
                            collectionslist.removeChild(collectionslist.firstChild);
                          }
                          let collection;
                          let option;
                          for (collection in res.data) {
                            option = document.createElement("option");
                            option.value = res.data[collection].Collection;
                            option.label = res.data[collection].Collection;
                            document
                              .getElementById("genusList")
                              .appendChild(option);
                          }
                        });
                      }}
                    />
                    <datalist id="genusList">
                      
                    </datalist>
                    {formik.touched.genus && formik.errors.genus ? (
                      <div class="Error">{formik.errors.genus}</div>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td class="BasicInfoLabel">
                    <label
                      class="entry-component FormLabel" //added commented out class FormLabel to this class
                      className="font-weight-bold"
                      //  class="FormLabel"
                    >
                      Species{" "}
                    </label>
                  </td>
                  <td class="BasicInput">
                    <input
                      id="species"
                      name="species"
                      type="string"
                      onChange={formik.handleChange}
                      value={formik.values.species}
                    />
                    {formik.touched.species && formik.errors.species ? (
                      <div class="Error">{formik.errors.species}</div>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td class="BasicInfoLabel">
                    <label
                      class="entry-component FormLabel" //added commented out class FormLabel to this class
                      className="font-weight-bold"
                      // class="FormLabel"
                    >
                     Date Entered{" "}
                    </label>
                  </td>
                  <td class="BasicInput">
                    <input
                      id="dateEntered"
                      name="dateEntered"
                      type="date"
                      onChange={formik.handleChange}
                      value={formik.values.dateEntered}
                    />
                    {formik.touched.dateEntered && formik.errors.dateEntered ? (
                      <div class="Error">{formik.errors.dateEntered}</div>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td class="BasicInfoLabel">
                    <label
                      class="entry-component FormLabel" //added commented out class FormLabel to this class
                      className="font-weight-bold"
                      //  class="FormLabel"
                    >
                      Date Obs.
                    </label>
                  </td>
                  <td class="BasicInput">
                    <input
                      id="dateObserved"
                      name="dateObserved"
                      type="date"
                      onChange={formik.handleChange}
                      value={formik.values.dateObserved}
                    />
                    <button
                      class="search btn btn-success"
                      type="button"
                      onClick={() => {
                        formik.values.dateObserved = formik.values.dateEntered;
                        document.getElementById("dateObserved").value =
                          formik.values.dateEntered;
                      }}
                    >
                      Set to Date
                    </button>
                    {formik.touched.dateObserved &&
                    formik.errors.dateObserved ? (
                      <div class="Error">{formik.errors.dateObserved}</div>
                    ) : null}
                  </td>
                </tr>
              </table>
            </div>
            <div class="ObservationData">
              {" "}
              <label class="QuestionLabel" className="font-weight-bold">
                Breaking Leaf Buds Observed{" "}
              </label>
              <button
                type="button"
                class="btn btn-primary btn-sm moreInfo"
                data-toggle="collapse"
                data-target="#question1"
              ></button>
              <div id="question1" class="collapse Explanation">
                One or more breaking leaf buds are visible on the plant. A leaf
                bud is considered "breaking" once a green leaf tip is visible at
                the end of the bud, but before the first leaf from the bud has
                unfolded to expose the leaf stalk (petiole) or leaf base.
              </div>
              <div class="Responses">
                <input
                  id="breakingLeafBuds1"
                  name="breakingLeafBuds"
                  type="radio"
                  data-target="#yes1"
                  onChange={expand}
                  value="y"
                  onClick={onClickObserved(
                    formik,
                    "1",
                    "breakingLeafBuds",
                    "y"
                  )}
                />
                <label class="option" for="breakingLeafBuds1">
                  Yes{" "}
                </label>
                <input
                  id="breakingLeafBuds2"
                  name="breakingLeafBuds"
                  type="radio"
                  data-target="#yes1"
                  data-collapse="#breakingLeafBudsIntensity"
                  onChange={collapse}
                  value="n"
                  onClick={onClickObserved(
                    formik,
                    "2",
                    "breakingLeafBuds",
                    "n"
                  )}
                />
                <label class="option" for="breakingLeafBuds2">
                  No{" "}
                </label>
                <input
                  id="breakingLeafBuds3"
                  name="breakingLeafBuds"
                  type="radio"
                  data-target="#yes1"
                  data-collapse="#breakingLeafBudsIntensity"
                  onChange={expand}
                  value="?"
                  onClick={onClickObserved(
                    formik,
                    "3",
                    "breakingLeafBuds",
                    "?"
                  )}
                />
                <label class="option" for="breakingLeafBuds3">
                  ?{" "}
                </label>
                <input
                  id="breakingLeafBuds4"
                  name="breakingLeafBuds"
                  type="radio"
                  data-target="#yes1"
                  data-collapse="#breakingLeafBudsIntensity"
                  onChange={collapse}
                  value="d"
                  onClick={onClickObserved(
                    formik,
                    "4",
                    "breakingLeafBuds",
                    "d"
                  )}
                />
                <label class="option" for="breakingLeafBuds4">
                  Could not reliably observe{" "}
                </label>
              </div>
              {formik.touched.breakingLeafBuds &&
              formik.errors.breakingLeafBuds ? (
                <div class="Error">{formik.errors.breakingLeafBuds}</div>
              ) : null}
              <div id="yes1" class="collapse">
                <label class="QuestionLabel" className="font-weight-bold">
                  Breaking Leaf Bud Intensity{" "}
                </label>
                <button
                  type="button"
                  class="btn btn-info btn-sm moreInfo"
                  data-toggle="collapse"
                  data-target="#intensityQuestion1"
                ></button>
                <div id="intensityQuestion1" class="collapse Explanation">
                  How many buds are breaking?
                </div>
                <SelectResponses
                  selectName="breakingLeafBudsIntensity"
                  selectId="breakingLeafBudsIntensity"
                  optionId="noBreakingLeafBudsIntensity"
                  formik={formik}
                />
              </div>
              <label class="QuestionLabel" className="font-weight-bold">
                Leaf Observed{" "}
              </label>
              <button
                type="button"
                class="moreInfo btn btn-primary btn-sm"
                data-toggle="collapse"
                data-target="#question2"
              ></button>
              <div class="collapse Explanation" id="question2">
                {" "}
                One or more live, unfolded leaves are visible on the plant. A
                leaf is considered "unfolded" once its entire length has emerged
                from a breaking bud, stem node or growing stem tip, so that the
                leaf stalk (petiole) or leaf base is visible at its point of
                attachment to the stem. Do not include fully dried or dead
                leaves.
              </div>
              <div class="Responses">
                <input
                  id="leafObserved1"
                  name="leafObserved"
                  type="radio"
                  data-target="#yes2,#leaf-questions"
                  onChange={expand}
                  value="y"
                  onClick={onClickObserved(formik, "1", "leafObserved", "y")}
                />
                <label class="option" for="leafObserved1">
                  Yes
                </label>
                <input
                  id="leafObserved2"
                  name="leafObserved"
                  type="radio"
                  data-target="#yes2,#leaf-questions"
                  data-collapse="#leafIntensity"
                  onChange={collapse}
                  value="n"
                  onClick={onClickObserved(formik, "2", "leafObserved", "n")}
                />
                <label class="option" for="leafObserved2">
                  No
                </label>
                <input
                  id="leafObserved3"
                  name="leafObserved"
                  type="radio"
                  data-target="#yes2,#leaf-questions"
                  data-collapse="#leafIntensity"
                  onChange={expand}
                  value="?"
                  onClick={onClickObserved(formik, "3", "leafObserved", "?")}
                />
                <label class="option" for="leafObserved3">
                  ?
                </label>
                <input
                  id="leafObserved4"
                  name="leafObserved"
                  type="radio"
                  data-target="#yes2,#leaf-questions"
                  data-collapse="#leafIntensity"
                  onChange={collapse}
                  value="d"
                  onClick={onClickObserved(formik, "4", "leafObserved", "d")}
                />
                <label class="option" for="leafObserved4">
                  Could not reliably observe
                </label>
              </div>
              {formik.touched.leafObserved && formik.errors.leafObserved ? (
                <div class="Error">{formik.errors.leafObserved}</div>
              ) : null}
              <div id="yes2" class="collapse">
                <label class="QuestionLabel" className="font-weight-bold">
                  Leaf Intensity{" "}
                </label>

                <button
                  type="button"
                  class="moreInfo btn btn-info btn-sm"
                  data-toggle="collapse"
                  data-target="#intensityQuestion2"
                ></button>
                <div id="intensityQuestion2" class="collapse Explanation">
                  What percentage of the potential canopy space is full with
                  leaves? Ignore dead branches in your estimate of potential
                  canopy space.
                </div>
                <SelectResponses
                  selectName="leafIntensity"
                  selectId="leafIntensity"
                  optionId="noLeafIntensity"
                  formik={formik}
                />
              </div>
              <div class="collapse" id="leaf-questions">
                <label class="QuestionLabel" className="font-weight-bold">
                  Leaf Increasing in Size{" "}
                </label>
                <button
                  type="button"
                  class="btn btn-primary btn-sm moreInfo"
                  data-toggle="collapse"
                  data-target="#question4"
                ></button>
                <div id="question4" class="collapse Explanation">
                  A majority of leaves on the plant have not yet reached their
                  full size and are still growing larger. Do not include new
                  leaves that continue to emerge at the ends of elongating stems
                  throughout the growing season.
                </div>
                <div class="Responses">
                  <input
                    id="leafIncreasingSize1"
                    name="leafIncreasingSize"
                    type="radio"
                    data-target="#yes4"
                    onChange={expand}
                    value="y"
                    onClick={onClickObserved(
                      formik,
                      "1",
                      "leafIncreasingSize",
                      "y"
                    )}
                  />
                  <label class="option" for="leafIncreasingSize1">
                    Yes
                  </label>
                  <input
                    id="leafIncreasingSize2"
                    name="leafIncreasingSize"
                    type="radio"
                    data-target="#yes4"
                    data-collapse="#leafIncreasingInSizeIntensity"
                    onChange={collapse}
                    value="n"
                    onClick={onClickObserved(
                      formik,
                      "2",
                      "leafIncreasingSize",
                      "n"
                    )}
                  />
                  <label class="option" for="leafIncreasingSize2">
                    No
                  </label>
                  <input
                    id="leafIncreasingSize3"
                    name="leafIncreasingSize"
                    type="radio"
                    data-target="#yes4"
                    data-collapse="#leafIncreasingInSizeIntensity"
                    onChange={expand}
                    value="?"
                    onClick={onClickObserved(
                      formik,
                      "3",
                      "leafIncreasingSize",
                      "?"
                    )}
                  />
                  <label class="option" for="leafIncreasingSize3">
                    ?
                  </label>
                  <input
                    id="leafIncreasingSize4"
                    name="leafIncreasingSize"
                    type="radio"
                    data-target="#yes4"
                    data-collapse="#leafIncreasingInSizeIntensity"
                    onChange={collapse}
                    value="d"
                    onClick={onClickObserved(
                      formik,
                      "4",
                      "leafIncreasingSize",
                      "d"
                    )}
                  />
                  <label class="option" for="leafIncreasingSize4">
                    Could not reliably observe
                  </label>
                </div>
                {formik.touched.leafIncreasingSize &&
                formik.errors.leafIncreasingSize ? (
                  <div class="Error">{formik.errors.leafIncreasingSize}</div>
                ) : null}
                <div id="yes4" class="collapse">
                  <label class="QuestionLabel" className="font-weight-bold">
                    Leaf Increasing in Size Intensity{" "}
                  </label>

                  <button
                    type="button"
                    class="btn btn-info btn-sm moreInfo"
                    data-toggle="collapse"
                    data-target="#intensityQuestion4"
                  ></button>
                  <div id="intensityQuestion4" class="collapse Explanation">
                    If leaves are still increasing in size, what percentage of
                    full size are most leaves?
                  </div>
                  <SelectResponses
                    selectName="leafIncreasingInSizeIntensity"
                    selectId="leafIncreasingInSizeIntensity"
                    optionId="noLeafIncreasingInSizeIntensity"
                    formik={formik}
                  />
                </div>
                <label class="QuestionLabel" className="font-weight-bold">
                  Leaf Color Observed{" "}
                </label>
                <button
                  type="button"
                  class="btn btn-primary btn-sm moreInfo"
                  data-toggle="collapse"
                  data-target="#question3"
                ></button>
                <div id="question3" class="Explanation collapse">
                  One or more leaves show some of their typical late-season
                  color, or yellow or brown due to drought or other stresses. Do
                  not include small spots of color due to minor leaf damage, or
                  dieback on branches that have broken. Do not include fully
                  dried or dead leaves that remain on the plant.
                </div>
                <div class="Responses">
                  <input
                    id="leafColorObserved1"
                    name="leafColorObserved"
                    type="radio"
                    data-target="#yes3"
                    onChange={expand}
                    value="y"
                    onClick={onClickObserved(
                      formik,
                      "1",
                      "leafColorObserved",
                      "y"
                    )}
                  />
                  <label class="option" for="leafColorObserved1">
                    Yes
                  </label>
                  <input
                    id="leafColorObserved2"
                    name="leafColorObserved"
                    type="radio"
                    data-target="#yes3"
                    data-collapse="#leafColorIntensity"
                    onChange={collapse}
                    value="n"
                    onClick={onClickObserved(
                      formik,
                      "2",
                      "leafColorObserved",
                      "n"
                    )}
                  />
                  <label class="option" for="leafColorObserved2">
                    No
                  </label>
                  <input
                    id="leafColorObserved3"
                    name="leafColorObserved"
                    type="radio"
                    data-target="#yes3"
                    data-collapse="#leafColorIntensity"
                    onChange={expand}
                    value="?"
                    onClick={onClickObserved(
                      formik,
                      "3",
                      "leafColorObserved",
                      "?"
                    )}
                  />
                  <label class="option" for="leafColorObserved3">
                    ?
                  </label>
                  <input
                    id="leafColorObserved4"
                    name="leafColorObserved"
                    type="radio"
                    data-target="#yes3"
                    data-collapse="#leafColorIntensity"
                    onChange={collapse}
                    value="d"
                    onClick={onClickObserved(
                      formik,
                      "4",
                      "leafColorObserved",
                      "d"
                    )}
                  />
                  <label class="option" for="leafColorObserved4">
                    Could not reliably observe
                  </label>
                </div>
                {formik.touched.leafColorObserved &&
                formik.errors.leafColorObserved ? (
                  <div class="Error">{formik.errors.leafColorObserved}</div>
                ) : null}
                <div id="yes3" class="collapse">
                  <label class="QuestionLabel" className="font-weight-bold">
                    Leaf Color Intensity{" "}
                  </label>

                  <button
                    type="button"
                    class="btn btn-info btn-sm moreInfo"
                    data-toggle="collapse"
                    data-target="#intensityQuestion3"
                  ></button>
                  <div id="intensityQuestion3" class="collapse Explanation">
                    What percentage of the potential canopy space is full with
                    non-green leaf color? Ignore dead branches in your estimate
                    of potential canopy space.
                  </div>
                  <SelectResponses
                    selectName="leafColorIntensity"
                    selectId="leafColorIntensity"
                    optionId="noLeafColorIntensity"
                    formik={formik}
                  />
                </div>

                <label class="QuestionLabel" className="font-weight-bold">
                  Leaf Falling Observed{" "}
                </label>
                <button
                  type="button"
                  class="btn btn-primary btn-sm moreInfo"
                  data-toggle="collapse"
                  data-target="#question5"
                ></button>
                <div id="question5" class="collapse Explanation">
                  One or more leaves are falling or have recently fallen from
                  the plant.
                </div>
                <div class="Responses">
                  <input
                    id="leafFallingObserved1"
                    name="leafFallingObserved"
                    type="radio"
                    onChange={formik.handleChange}
                    value="y"
                  />
                  <label class="option" for="leafFallingObserved1">
                    Yes
                  </label>
                  <input
                    id="leafFallingObserved2"
                    name="leafFallingObserved"
                    type="radio"
                    onChange={formik.handleChange}
                    value="n"
                  />
                  <label class="option" for="leafFallingObserved2">
                    No
                  </label>
                  <input
                    id="leafFallingObserved3"
                    name="leafFallingObserved"
                    type="radio"
                    onChange={formik.handleChange}
                    value="?"
                  />
                  <label class="option" for="leafFallingObserved3">
                    ?
                  </label>
                  <input
                    id="leafFallingObserved4"
                    name="leafFallingObserved"
                    type="radio"
                    onChange={formik.handleChange}
                    value="d"
                  />
                  <label class="option" for="leafFallingObserved4">
                    Could not reliably observe
                  </label>
                </div>
                {formik.touched.leafFallingObserved &&
                formik.errors.leafFallingObserved ? (
                  <div class="Error">{formik.errors.leafFallingObserved}</div>
                ) : null}
              </div>
              <label class="QuestionLabel" className="font-weight-bold">
                Flower/Flower Buds Observed{" "}
              </label>
              <button
                type="button"
                class="btn btn-primary btn-sm moreInfo"
                data-toggle="collapse"
                data-target="#question6"
              ></button>
              <div id="question6" class="collapse Explanation">
                One or more flower buds are visible on the plant. Include flower
                buds or inflorescences that are swelling or expanding, but do
                not include those that are tightly closed and not actively
                growing (dormant). For Quercus, the male (staminate)
                inflorescence is a catkin which is initially compact and stiff,
                but eventually unfolds to become longer and hang loosely from
                the branch. Female (pistillate) flowers are very small and
                petal-less, emerging from the growing stem at the point where a
                new leaf is attached.
              </div>
              <div class="Responses">
                <input
                  id="flowerBudsObserved1"
                  name="flowerBudsObserved"
                  type="radio"
                  data-target="#yes6,#flower-questions"
                  onChange={expand}
                  value="y"
                  onClick={onClickObserved(
                    formik,
                    "1",
                    "flowerBudsObserved",
                    "y"
                  )}
                />
                <label class="option" for="flowerBudsObserved1">
                  Yes
                </label>
                <input
                  id="flowerBudsObserved2"
                  name="flowerBudsObserved"
                  type="radio"
                  data-target="#yes6,#flower-questions"
                  data-collapse="#flowerBudsIntensity"
                  onChange={collapse}
                  value="n"
                  onClick={onClickObserved(
                    formik,
                    "2",
                    "flowerBudsObserved",
                    "n"
                  )}
                />
                <label class="option" for="flowerBudsObserved2">
                  No
                </label>
                <input
                  id="flowerBudsObserved3"
                  name="flowerBudsObserved"
                  type="radio"
                  data-target="#yes6,#flower-questions"
                  data-collapse="#flowerBudsIntensity"
                  onChange={expand}
                  value="?"
                  onClick={onClickObserved(
                    formik,
                    "3",
                    "flowerBudsObserved",
                    "?"
                  )}
                />
                <label class="option" for="flowerBudsObserved3">
                  ?
                </label>
                <input
                  id="flowerBudsObserved4"
                  name="flowerBudsObserved"
                  type="radio"
                  data-target="#yes6,#flower-questions"
                  data-collapse="#flowerBudsIntensity"
                  onChange={collapse}
                  value="d"
                  onClick={onClickObserved(
                    formik,
                    "4",
                    "flowerBudsObserved",
                    "d"
                  )}
                />
                <label class="option" for="flowerBudsObserved4">
                  Could not reliably observe
                </label>
              </div>
              {formik.touched.flowerBudsObserved &&
              formik.errors.flowerBudsObserved ? (
                <div class="Error">{formik.errors.flowerBudsObserved}</div>
              ) : null}
              <div id="yes6" class="collapse">
                <label class="QuestionLabel" className="font-weight-bold">
                  Flower/Flower Buds Intensity{" "}
                </label>

                <button
                  type="button"
                  class="btn btn-info btn-sm moreInfo"
                  data-toggle="collapse"
                  data-target="#intensityQuestion6"
                ></button>
                <div id="intensityQuestion6" class="collapse Explanation">
                  For species in which individual flowers are clustered in
                  flower heads, spikes or catkins (inflorescences), simply
                  estimate the number of flower heads, spikes or catkins and not
                  the number of individual flowers.
                </div>
                <SelectResponses
                  selectName="flowerBudsIntensity"
                  selectId="flowerBudsIntensity"
                  optionId="noFlowerBudsIntensity"
                  formik={formik}
                />
              </div>
              <div id="flower-questions" class="collapse">
                <label class="QuestionLabel" className="font-weight-bold">
                  Flower Open Observed{" "}
                </label>
                <button
                  type="button"
                  class="btn btn-primary btn-sm moreInfo"
                  data-toggle="collapse"
                  data-target="#question7"
                ></button>
                <div id="question7" class="collapse Explanation">
                  One or more open, fresh flowers are visible on the plant.
                  Flowers are considered "open" when the reproductive parts
                  (male stamens or female pistils) are visible between or within
                  unfolded or open flower parts (petals, floral tubes or
                  sepals). Do not include wilted or dried flowers. For Quercus,
                  the male flowers will open once the initially compact catkin
                  has unfolded and is hanging loosely. Female flowers are open
                  when the pistils are visible, but will be very difficult to
                  see where they are out of reach.
                </div>
                <div class="Responses">
                  <input
                    id="flowerOpenObserved1"
                    name="flowerOpenObserved"
                    type="radio"
                    data-target="#yes7"
                    onChange={expand}
                    value="y"
                    onClick={onClickObserved(
                      formik,
                      "1",
                      "flowerOpenObserved",
                      "y"
                    )}
                  />
                  <label class="option" for="flowerOpenObserved1">
                    Yes
                  </label>
                  <input
                    id="flowerOpenObserved2"
                    name="flowerOpenObserved"
                    type="radio"
                    data-target="#yes7"
                    data-collapse="#flowerOpenIntensity"
                    onChange={collapse}
                    value="n"
                    onClick={onClickObserved(
                      formik,
                      "2",
                      "flowerOpenObserved",
                      "n"
                    )}
                  />
                  <label class="option" for="flowerOpenObserved2">
                    No
                  </label>
                  <input
                    id="flowerOpenObserved3"
                    name="flowerOpenObserved"
                    type="radio"
                    data-target="#yes7"
                    data-collapse="#flowerOpenIntensity"
                    onChange={expand}
                    value="?"
                    onClick={onClickObserved(
                      formik,
                      "3",
                      "flowerOpenObserved",
                      "?"
                    )}
                  />
                  <label class="option" for="flowerOpenObserved3">
                    ?
                  </label>
                  <input
                    id="flowerOpenObserved4"
                    name="flowerOpenObserved"
                    type="radio"
                    data-target="#yes7"
                    data-collapse="#flowerOpenIntensity"
                    onChange={collapse}
                    value="d"
                    onClick={onClickObserved(
                      formik,
                      "4",
                      "flowerOpenObserved",
                      "d"
                    )}
                  />
                  <label class="option" for="flowerOpenObserved4">
                    Could not reliably observe
                  </label>
                </div>
                {formik.touched.flowerOpenObserved &&
                formik.errors.flowerOpenObserved ? (
                  <div class="Error">{formik.errors.flowerOpenObserved}</div>
                ) : null}
                <div id="yes7" class="collapse">
                  <label class="QuestionLabel" className="font-weight-bold">
                    Flower Open Intensity{" "}
                  </label>

                  <button
                    type="button"
                    class="btn btn-info btn-sm moreInfo"
                    data-toggle="collapse"
                    data-target="#intensityQuestion7"
                  ></button>
                  <div id="intensityQuestion7" class="collapse Explanation">
                    For species in which individual flowers are clustered in
                    flower heads, spikes or catkins (inflorescences), estimate
                    the percentage of all individual flowers that are open.
                  </div>
                  <SelectResponses
                    selectName="flowerOpenIntensity"
                    selectId="flowerOpenIntensity"
                    optionId="noFlowerOpenIntensity"
                    formik={formik}
                  />
                </div>
                <label class="QuestionLabel" className="font-weight-bold">
                  Flower Pollen Release Observed{" "}
                </label>
                <button
                  type="button"
                  class="btn btn-primary btn-sm moreInfo"
                  data-toggle="collapse"
                  data-target="#question8"
                ></button>
                <div id="question8" class="collapse Explanation">
                  One or more flowers on the plant release visible pollen grains
                  when gently shaken or blown into your palm or onto a dark
                  surface.
                </div>
                <div class="Responses">
                  <input
                    id="flowerPollenObserved1"
                    name="flowerPollenObserved"
                    type="radio"
                    data-target="#yes8"
                    onChange={expand}
                    value="y"
                    onClick={onClickObserved(
                      formik,
                      "1",
                      "flowerPollenObserved",
                      "y"
                    )}
                  />
                  <label class="option" for="flowerPollenObserved1">
                    Yes
                  </label>
                  <input
                    id="flowerPollenObserved2"
                    name="flowerPollenObserved"
                    type="radio"
                    data-target="#yes8"
                    data-collapse="#flowerPollenReleaseIntensity"
                    onChange={collapse}
                    value="n"
                    onClick={onClickObserved(
                      formik,
                      "2",
                      "flowerPollenObserved",
                      "n"
                    )}
                  />
                  <label class="option" for="flowerPollenObserved2">
                    No
                  </label>
                  <input
                    id="flowerPollenObserved3"
                    name="flowerPollenObserved"
                    type="radio"
                    data-target="#yes8"
                    data-collapse="#flowerPollenReleaseIntensity"
                    onChange={expand}
                    value="?"
                    onClick={onClickObserved(
                      formik,
                      "3",
                      "flowerPollenObserved",
                      "?"
                    )}
                  />
                  <label class="option" for="flowerPollenObserved3">
                    ?
                  </label>
                  <input
                    id="flowerPollenObserved4"
                    name="flowerPollenObserved"
                    type="radio"
                    data-target="#yes8"
                    data-collapse="#flowerPollenReleaseIntensity"
                    onChange={collapse}
                    value="d"
                    onClick={onClickObserved(
                      formik,
                      "4",
                      "flowerPollenObserved",
                      "d"
                    )}
                  />
                  <label class="option" for="flowerPollenObserved4">
                    Could not reliably observe
                  </label>
                </div>
                {formik.touched.flowerPollenObserved &&
                formik.errors.flowerPollenObserved ? (
                  <div class="Error">{formik.errors.flowerPollenObserved}</div>
                ) : null}
                <div id="yes8" class="collapse">
                  <label class="QuestionLabel" className="font-weight-bold">
                    Flower Pollen Release Intensity{" "}
                  </label>

                  <button
                    type="button"
                    class="btn btn-info btn-sm moreInfo"
                    data-toggle="collapse"
                    data-target="#intensityQuestion8"
                  ></button>
                  <div id="intensityQuestion8" class="collapse  Explanation">
                    Little: Only a few grains are released. Some: Many grains
                    are released. Lots: A layer of pollen covers your palm, or a
                    cloud of pollen can be seen in the air when the wind blows.
                  </div>
                  <SelectResponses
                    selectName="flowerPollenReleaseIntensity"
                    selectId="flowerPollenReleaseIntensity"
                    optionId="noFlowerPollenReleaseIntensity"
                    formik={formik}
                  />
                </div>
              </div>
              <label class="QuestionLabel" className="font-weight-bold">
                Fruit Observed{" "}
              </label>
              <button
                type="button"
                class="btn btn-primary btn-sm moreInfo"
                data-bs-toggle="collapse"
                data-bs-target="#question9"
              ></button>
              <div id="question9" className="collapse Explanation">
                One or more fruits are visible on the plant. For Quercus, the
                fruit is a nut (acorn), partially covered with a "cap", that
                changes from green to yellow-green to light brown or dark red
                brown.
              </div>
              <div class="Responses">
                <input
                  id="fruitObserved1"
                  name="fruitObserved"
                  type="radio"
                  data-target="#yes9,#fruit-questions"
                  onChange={expand}
                  value="y"
                  onClick={onClickObserved(formik, "1", "fruitObserved", "y")}
                />
                <label class="option" for="fruitObserved1">
                  Yes
                </label>
                <input
                  id="fruitObserved2"
                  name="fruitObserved"
                  type="radio"
                  data-target="#yes9,#fruit-questions"
                  data-collapse="#fruitIntensity"
                  onChange={collapse}
                  value="n"
                  onClick={onClickObserved(formik, "2", "fruitObserved", "n")}
                />
                <label class="option" for="fruitObserved2">
                  No
                </label>
                <input
                  id="fruitObserved3"
                  name="fruitObserved"
                  type="radio"
                  data-target="#yes9,#fruit-questions"
                  data-collapse="#fruitIntensity"
                  onChange={expand}
                  value="?"
                  onClick={onClickObserved(formik, "3", "fruitObserved", "?")}
                />
                <label class="option" for="fruitObserved3">
                  ?
                </label>
                <input
                  id="fruitObserved4"
                  name="fruitObserved"
                  type="radio"
                  data-target="#yes9,#fruit-questions"
                  data-collapse="#fruitIntensity"
                  onChange={collapse}
                  value="d"
                  onClick={onClickObserved(formik, "4", "fruitObserved", "d")}
                />
                <label class="option" for="fruitObserved4">
                  Could not reliably observe
                </label>
              </div>
              {formik.touched.fruitObserved && formik.errors.fruitObserved ? (
                <div class="Error">{formik.errors.fruitObserved}</div>
              ) : null}
              <div id="yes9" class="collapse">
                <label class="QuestionLabel" className="font-weight-bold">
                  Fruit Intensity{" "}
                </label>

                <button
                  type="button"
                  class="btn btn-info btn-sm moreInfo"
                  data-toggle="collapse"
                  data-target="#intensityQuestion9"
                ></button>
                <div id="intensityQuestion9" class="collapse Explanation">
                  How many fruits are present?
                </div>
                <SelectResponses
                  selectName="fruitIntensity"
                  selectId="fruitIntensity"
                  optionId="noFruitIntensity"
                  formik={formik}
                />
              </div>
              <div id="fruit-questions" class="collapse">
                <label class="QuestionLabel" className="font-weight-bold">
                  Fruit Ripe Observed{" "}
                </label>
                <button
                  type="button"
                  class="btn btn-primary btn-sm moreInfo"
                  data-toggle="collapse"
                  data-target="#question10"
                ></button>
                <div id="question10" class="collapse  Explanation">
                  One or more ripe fruits are visible on the plant. For Quercus,
                  a fruit is considered ripe when it has turned light brown or
                  dark red brown.
                </div>
                <div class="Responses">
                  <input
                    id="fruitRipeObserved1"
                    name="fruitRipeObserved"
                    type="radio"
                    data-target="#yes10"
                    onChange={expand}
                    value="y"
                    onClick={onClickObserved(
                      formik,
                      "1",
                      "fruitRipeObserved",
                      "y"
                    )}
                  />
                  <label class="option" for="fruitRipeObserved1">
                    Yes
                  </label>
                  <input
                    id="fruitRipeObserved2"
                    name="fruitRipeObserved"
                    type="radio"
                    data-target="#yes10"
                    data-collapse="#fruitRipeIntensity"
                    onChange={collapse}
                    value="n"
                    onClick={onClickObserved(
                      formik,
                      "2",
                      "fruitRipeObserved",
                      "n"
                    )}
                  />
                  <label class="option" for="fruitRipeObserved2">
                    No
                  </label>
                  <input
                    id="fruitRipeObserved3"
                    name="fruitRipeObserved"
                    type="radio"
                    data-target="#yes10"
                    data-collapse="#fruitRipeIntensity"
                    onChange={expand}
                    value="?"
                    onClick={onClickObserved(
                      formik,
                      "3",
                      "fruitRipeObserved",
                      "?"
                    )}
                  />
                  <label class="option" for="fruitRipeObserved3">
                    ?
                  </label>
                  <input
                    id="fruitRipeObserved4"
                    name="fruitRipeObserved"
                    type="radio"
                    data-target="#yes10"
                    data-collapse="#fruitRipeIntensity"
                    onChange={collapse}
                    value="d"
                    onClick={onClickObserved(
                      formik,
                      "4",
                      "fruitRipeObserved",
                      "d"
                    )}
                  />
                  <label class="option" for="fruitRipeObserved4">
                    Could not reliably observe
                  </label>
                </div>
                {formik.touched.fruitRipeObserved &&
                formik.errors.fruitRipeObserved ? (
                  <div class="Error">{formik.errors.fruitRipeObserved}</div>
                ) : null}
                <div id="yes10" class="collapse">
                  <label class="QuestionLabel" className="font-weight-bold">
                    Fruit Ripe Intensity{" "}
                  </label>

                  <button
                    type="button"
                    class="btn btn-info btn-sm moreInfo"
                    data-toggle="collapse"
                    data-target="#intensityQuestion10"
                  ></button>
                  <div id="intensityQuestion10" class="collapse Explanation">
                    What percentage of all fruits on the plant are ripe?
                  </div>
                  <SelectResponses
                    selectName="fruitRipeIntensity"
                    selectId="fruitRipeIntensity"
                    optionId="noFruitRipeIntensity"
                    formik={formik}
                  />
                </div>
                <label class="QuestionLabel" className="font-weight-bold">
                  Fruit Drop Observed{" "}
                </label>
                <button
                  type="button"
                  class="btn btn-primary btn-sm moreInfo"
                  data-toggle="collapse"
                  data-target="#question11"
                ></button>
                <div id="question11" class="collapse Explanation">
                  One or more mature fruits or seeds have dropped or been
                  removed from the plant since your last visit. Do not include
                  obviously immature fruits that have dropped before ripening,
                  such as in a heavy rain or wind, or empty fruits that had long
                  ago dropped all of their seeds but remained on the plant.
                </div>
                <div class="Responses">
                  <input
                    id="fruitDropObserved1"
                    name="fruitDropObserved"
                    type="radio"
                    data-target="#yes11"
                    onChange={expand}
                    value="y"
                    onClick={onClickObserved(
                      formik,
                      "1",
                      "fruitDropObserved",
                      "y"
                    )}
                  />
                  <label class="option" for="fruitDropObserved1">
                    Yes
                  </label>
                  <input
                    id="fruitDropObserved2"
                    name="fruitDropObserved"
                    type="radio"
                    data-target="#yes11"
                    data-collapse="#fruitDropIntensity"
                    onChange={collapse}
                    value="n"
                    onClick={onClickObserved(
                      formik,
                      "2",
                      "fruitDropObserved",
                      "n"
                    )}
                  />
                  <label class="option" for="fruitDropObserved2">
                    No
                  </label>
                  <input
                    id="fruitDropObserved3"
                    name="fruitDropObserved"
                    type="radio"
                    data-target="#yes11"
                    data-collapse="#fruitDropIntensity"
                    onChange={expand}
                    value="?"
                    onClick={onClickObserved(
                      formik,
                      "3",
                      "fruitDropObserved",
                      "?"
                    )}
                  />
                  <label class="option" for="fruitDropObserved3">
                    ?
                  </label>
                  <input
                    id="fruitDropObserved4"
                    name="fruitDropObserved"
                    type="radio"
                    data-target="#yes11"
                    data-collapse="#fruitDropIntensity"
                    onChange={collapse}
                    value="d"
                    onClick={onClickObserved(
                      formik,
                      "4",
                      "fruitDropObserved",
                      "d"
                    )}
                  />
                  <label class="option" for="fruitDropObserved4">
                    Could not reliably observe
                  </label>
                </div>
                {formik.touched.fruitDropObserved &&
                formik.errors.fruitDropObserved ? (
                  <div class="Error">{formik.errors.fruitDropObserved}</div>
                ) : null}
                <div id="yes11" class="collapse">
                  <label class="QuestionLabel" className="font-weight-bold">
                    Fruit Drop Intensity{" "}
                  </label>

                  <button
                    type="button"
                    class="btn btn-info btn-sm moreInfo"
                    data-toggle="collapse"
                    data-target="#intensityQuestion11"
                  ></button>
                  <div id="intensityQuestion11" class="collapse Explanation">
                    How many mature fruits have dropped seeds or have completely
                    dropped or been removed from the plant since your last
                    visit?
                  </div>
                  <SelectResponses
                    selectName="fruitDropIntensity"
                    selectId="fruitDropIntensity"
                    optionId="noFruitDropIntensity"
                    formik={formik}
                  />
                </div>
              </div>
            </div>
            <div id="comments" class="comments">
              <div>
                <label class="QuestionLabel" className="font-weight-bold">
                  Comments(optional){" "}
                </label>
              </div>
              <textarea
                id="comments"
                name="comments"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.comments}
              />
            </div>
            <div class="submitForm">
              <button class="btn btn-success" onClick={handleOpen}>
                Submit
              </button>
            </div>
            <div>
              <Modal
                show={showConfirmationModal}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>Confirm Data Entry</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p white-space pre>
                    PlantID: {formik.values.plantId}
                    <br />
                    Observer: {formik.values.lastName}
                    <br></br>
                    Genus: {formik.values.genus}
                    <br></br>
                    Species: {formik.values.species}
                    <br></br>
                    Entry Date: {formik.values.dateEntered}
                    <br></br>
                    Date Observed: {formik.values.dateObserved}
                    <br></br>
                    <br></br>
                    Breaking Leaf Buds Observed:{" "}
                    {formik.values.breakingLeafBuds}
                    <br></br>
                    Leaf Observed: {formik.values.leafObserved}
                    <br></br>
                    Leaf Increasing in Size Observed:{" "}
                    {formik.values.leafIncreasingSize}
                    <br></br>
                    Leaf Color Observed: {formik.values.leafColorObserved}
                    <br></br>
                    Leaf Falling Observed: {formik.values.leafFallingObserved}
                    <br></br>
                    Flower Buds Observed: {formik.values.flowerBudsObserved}
                    <br></br>
                    Flower Open Observed: {formik.values.flowerOpenObserved}
                    <br></br>
                    Flower Pollen Observed: {formik.values.flowerPollenObserved}
                    <br></br>
                    Fruit Observed: {formik.values.fruitObserved}
                    <br></br>
                    Fruit Ripe Observed: {formik.values.fruitRipeObserved}
                    <br></br>
                    Fruit Drop Observed: {formik.values.fruitDropObserved}
                    <br></br>
                    <br></br>
                    Leaf Intensity: {formik.values.leafIntensity}
                    <br></br>
                    Breaking Leaf Buds Intensity:{" "}
                    {formik.values.breakingLeafBudsIntensity}
                    <br></br>
                    Leaf Increasing In Size Intensity:{" "}
                    {formik.values.leafIncreasingInSizeIntensity}
                    <br></br>
                    Leaf Color Intensity: {formik.values.leafColorIntensity}
                    <br></br>
                    Flower Buds Intensity: {formik.values.flowerBudsIntensity}
                    <br></br>
                    Flower Open Intensity: {formik.values.flowerOpenIntensity}
                    <br></br>
                    Flower Pollen Release Intensity:{" "}
                    {formik.values.flowerPollenReleaseIntensity}
                    <br></br>
                    Fruit Intensity: {formik.values.fruitIntensity}
                    <br></br>
                    Fruit Ripe Intensity: {formik.values.fruitRipeIntensity}
                    <br></br>
                    Fruit Drop Intensity: {formik.values.fruitDropIntensity}
                    <br></br>
                    <br></br>
                    Comments: {formik.values.comments}
                  </p>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="primary" onClick={handleClose}>
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => {
                      formik.handleSubmit();
                      handleClose();
                    }}
                  >
                    Confirm
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DataForm;
